var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconEyeComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? true : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-eye ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8016 7.90454C13.8221 7.96653 13.8221 8.03282 13.8016 8.09481C13.5888 8.73567 13.0675 9.7254 12.1923 10.6006C11.1833 11.6096 9.80646 12.3711 7.99994 12.3711C6.19343 12.3711 4.81658 11.6096 3.80762 10.6006C2.93239 9.7254 2.41111 8.73567 2.19833 8.09481C2.17775 8.03282 2.17775 7.96653 2.19833 7.90454C2.41111 7.26368 2.93239 6.27395 3.80762 5.39872C4.81658 4.38976 6.19343 3.62825 7.99994 3.62825C9.80646 3.62825 11.1833 4.38976 12.1923 5.39872C13.0675 6.27395 13.5888 7.26368 13.8016 7.90454ZM7.99994 13.6663C12.6084 13.6663 14.9414 9.76548 15.3199 8.0631C15.3294 8.02014 15.3294 7.97921 15.3199 7.93625C14.9414 6.23387 12.6084 2.33301 7.99994 2.33301C3.39147 2.33301 1.0585 6.23387 0.680015 7.93625C0.670464 7.97921 0.670464 8.02014 0.680015 8.0631C1.0585 9.76548 3.39147 13.6663 7.99994 13.6663Z",
    fillOpacity: "1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99994 9.0711C7.40821 9.0711 6.92852 8.59141 6.92852 7.99967C6.92852 7.40794 7.40821 6.92825 7.99994 6.92825C8.59168 6.92825 9.07137 7.40794 9.07137 7.99967C9.07137 8.59141 8.59168 9.0711 7.99994 9.0711ZM7.99994 10.4997C9.38066 10.4997 10.4999 9.38039 10.4999 7.99967C10.4999 6.61896 9.38066 5.49967 7.99994 5.49967C6.61923 5.49967 5.49994 6.61896 5.49994 7.99967C5.49994 9.38039 6.61923 10.4997 7.99994 10.4997Z",
    fillOpacity: "1"
  }));
}
var IconEye = /*#__PURE__*/React.forwardRef(IconEyeComponent);
export default IconEye;